import t from "./index2.js";
import { openBlock as s, createElementBlock as n, createElementVNode as o, toDisplayString as r, createCommentVNode as p } from "vue";
import "./index3.js";
import a from "../../../../_virtual/index.js";
const c = { class: "csr-phone-number" }, h = ["href"], m = { class: "text" }, i = { class: "phone-number" }, _ = {
  key: 0,
  class: "phone-hours"
};
function d(e, l, u, f, b, N) {
  return s(), n("div", c, [
    o("a", {
      href: e.phoneNumberLink,
      rel: "nofollow"
    }, [
      o("span", m, [
        o("span", i, r(e.phoneNumber), 1),
        e.showPhoneHours ? (s(), n("span", _, r(e.phoneHours), 1)) : p("", !0)
      ])
    ], 8, h)
  ]);
}
const y = /* @__PURE__ */ a(t, [["render", d], ["__scopeId", "data-v-8ef3a5c0"]]);
export {
  y as default
};
//# sourceMappingURL=index.js.map
